import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import 'slick-carousel'

export default component((node, ctx) => {
  
//   const imageToggles = node.querySelectorAll('.js-mm-item')

    var slider = $('.js-feature-slider');

    var nav = $('.js-feature-slider-nav');

    $('.js-feature-slider').on('init', function(event, slick){
        $('.js-progress[data-index="0"').addClass('active');
    });

    slider.slick({
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        asNavFor: nav
    });

    $('.js-feature-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.js-nav-item').removeClass('active');
        $('.js-nav-item[data-index="' + nextSlide + '"').addClass('active');

        $('.js-progress').removeClass('active');
        $('.js-progress[data-index="' + nextSlide + '"').addClass('active');
    });

    nav.slick({
        arrows: false,
        dots: true,
        fade: true,
        asNavFor: slider
    });

    $('.js-nav-item').click(function() {
        $('.js-feature-slider').slick('slickGoTo', $(this).data('index'));
        $('.js-nav-item').removeClass('active');
        $(this).addClass('active');
    });
    
})
